import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FiPhone, FiMenu, FiX } from "react-icons/fi";
import { motion } from "framer-motion";
import logoImg from "../Images/logo.png";
import { services,industries } from "../Data";


const Header = () => {
  const [openDropdown, setOpenDropdown] = useState(null); // desktop dropdowns
  const [sidebarOpen, setSidebarOpen] = useState(false); // mobile sidebar
  const [sidebarDropdown, setSidebarDropdown] = useState(null); // mobile dropdown toggle
  const navigate = useNavigate();

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  const toggleSidebarDropdown = (name) => {
    setSidebarDropdown(sidebarDropdown === name ? null : name);
  };

  const handleNavigate = (path) => {
    setOpenDropdown(null);
    setSidebarDropdown(null);
    setSidebarOpen(false);
    navigate(path);
  };

  return (
    <header className="header">
      {/* ===== TOP BAR ===== */}
      <motion.div
        className="top-bar"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <div className="top-inner">
          {/* LOGO */}
          <div className="logo" onClick={() => navigate("/")}>
            <img src={logoImg} alt="Shivam Transworld Logo" />
          </div>

          {/* INFO (desktop only) */}
          <div className="top-info desktop-only">
            {/*<div>
              <FiClock />
              <div>
                <strong>Sunday CLOSED</strong>
                <span>MON - SAT 8.00 - 18.00</span>
              </div>
            </div>*/}
            <div>
              <FiPhone />
             <div>
  <strong>Get in Touch</strong>
  <a href="tel:+919132287287">
    <span>+91 9132 287 287</span>
  </a>
</div>
            </div>
           {/* <div>
              <FiMapPin />
              <div>
                <strong>Shop No : 70 / 1
Tanker's Association Building,

</strong>
                <span>Beside S T Bus Station,NH - 8A, Gandhidham - 370201</span>
              </div>
            </div>*/}
          </div>

          {/* Hamburger button (mobile only) */}
          <button
            className="hamburger-btn mobile-only"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            {sidebarOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </motion.div>

      {/* ===== NAV BAR (desktop) ===== */}
      <div className="nav-bar desktop-only">
        <nav className="nav-links">
          <NavLink to="/" end className="nav-item">
            Home
          </NavLink>
          <NavLink to="/about-us" className="nav-item">
            About
          </NavLink>

          <div
            className={`dropdown nav-item ${
              openDropdown === "services" ? "show" : ""
            }`}
            onMouseEnter={() =>
              window.innerWidth > 768 && setOpenDropdown("services")
            }
            onMouseLeave={() =>
              window.innerWidth > 768 && setOpenDropdown(null)
            }
          >
            <button onClick={() => {
    handleNavigate("/services");
    toggleDropdown("services");
  }}>
              Services ▾
            </button>
            <div className="dropdown-menu">
      {services.map((service, index) => (
        <p
          key={index}
          onClick={() => handleNavigate(`/services/${service.slug}`)}
        >
          {service.title || "Service"}
        </p>
      ))}
    </div>
          </div>

          <div
            className={`dropdown nav-item ${
              openDropdown === "industries" ? "show" : ""
            }`}
            onMouseEnter={() =>
              window.innerWidth > 768 && setOpenDropdown("industries")
            }
            onMouseLeave={() =>
              window.innerWidth > 768 && setOpenDropdown(null)
            }
          >
            <button onClick={() => {
    handleNavigate("/industries");
    toggleDropdown("industries");
  }}>
              Industries ▾
            </button>
             <div className="dropdown-menu">
      {industries.map((industry, index) => (
        <p
          key={index}
          onClick={() => handleNavigate(`/industries/${industry.slug}`)}
        >
      {industry.title.replace(/,/g, ", ")}
        </p>
      ))}
    </div>
          </div>

          <NavLink to="/contact-us" className="nav-item">
            Contact Us
          </NavLink>

          <button
            className="enquire-btn"
            onClick={() => handleNavigate("/enquiry#enquiry-form")}
          >
            Enquire Now
          </button>
        </nav>
      </div>

      {/* ===== SIDEBAR (mobile) ===== */}
      <div className={`sidebar ${sidebarOpen ? "active" : ""}`}>
        {/* LOGO */}
        <div className="logo" onClick={() => handleNavigate("/")}>
          <img src={logoImg} alt="Shivam Transworld Logo" />
        </div>

        {/* NAV LINKS */}
        <div className="sidebar-nav">
          <NavLink to="/" end className="nav-item" onClick={() => setSidebarOpen(false)}>
            Home
          </NavLink>
          <NavLink to="/about-us" className="nav-item" onClick={() => setSidebarOpen(false)}>
            About
          </NavLink>

          {/* Services Dropdown */}
          <div className="dropdown sidebar-dropdown">
            <button onClick={() => toggleSidebarDropdown("services")}>
              Services ▾
            </button>
            <div className={`dropdown-menu ${sidebarDropdown === "services" ? "show" : ""}`}>
              {services.map((service, index) => (
        <p
          key={index}
          onClick={() => handleNavigate(`/services/${service.slug}`)}
        >
          {service.title || "Service"}
        </p>
      ))}
            </div>
          </div>

          {/* Industries Dropdown */}
          <div className="dropdown sidebar-dropdown">
            <button onClick={() => toggleSidebarDropdown("industries")}>
              Industries ▾
            </button>
            <div className={`dropdown-menu ${sidebarDropdown === "industries" ? "show" : ""}`}>
           {industries.map((industry, index) => (
        <p
          key={index}
          onClick={() => handleNavigate(`/industries/${industry.slug}`)}
        >
          {industry.title}
        </p>
      ))}
            </div>
          </div>

          <NavLink to="/contact-us" className="nav-item" onClick={() => setSidebarOpen(false)}>
            Contact Us
          </NavLink>

          <button
            className="enquire-btn"
            onClick={() => handleNavigate("/enquiry#enquiry-form")}
          >
            Enquire Now
          </button>
        </div>

        {/* FOOTER INFO */}
        <div className="sidebar-info">
          {/*<div>
            <FiClock />
            <div>
              <strong>Sunday CLOSED</strong>
              <span>MON - SAT 8.00 - 18.00</span>
            </div>
          </div>*/}

          <div>
            <FiPhone />
            <div>
              <strong>Get in Touch</strong>
             <a href="tel:+919132287287">
  <span>+91 9132 287 287</span>
</a>
            </div>
          </div>

          {/*<div>
            <FiMapPin />
            <div>
              <strong>Shop No : 70 / 1
Tanker's Association Building,
</strong>
              <span>Beside S T Bus Station,NH - 8A, Gandhidham - 370201</span>
            </div>
          </div>*/}
        </div>
      </div>
    </header>
  );
};

export default Header;
